import React from 'react';

type UserImageProps = {
  src: string;
  className: string;
};

const UserImage: React.FC<UserImageProps> = ({ src, className }) => (
  <img src={src || '/img/user/default.png'} className={className} />
);

export default UserImage;
